import {
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";

const STATUS_OPTIONS = [
  { value: "", label: "ທັງໝົດ" },
  { value: "open", label: "ເປີດ" },
  { value: "reviewing", label: "ກຳລັງກວດສອບ" },
  { value: "actioned", label: "ດຳເນີນການແລ້ວ" },
  { value: "dismissed", label: "ປິດລາຍງານ" },
];

const TARGET_TYPE_OPTIONS = [
  { value: "", label: "ທັງໝົດ" },
  { value: "listing", label: "ລາຍການສິນຄ້າ" },
  { value: "review", label: "ຄຳແນະນຳ" },
  { value: "shop", label: "ຮ້ານຄ້າ" },
  { value: "mechanic", label: "ຊ່າງແປງ" },
  { value: "job", label: "ວຽກ" },
];

export function ReportsFilter() {
  const navigate = useNavigate({ from: "/app/moderation/reports" });
  const search = useSearch({
    from: "/app/moderation/reports",
  }) as OffsetPageQueryDTO & {
    status?: string;
    targetType?: string;
  };

  const filters = search.filters ?? [];
  const statusFilter = filters.find(
    (f: { field: string }) => f.field === "status",
  );
  const targetTypeFilter = filters.find(
    (f: { field: string }) => f.field === "targetType",
  );
  const currentStatus =
    (statusFilter as { value?: string } | undefined)?.value ?? "";
  const currentTargetType =
    (targetTypeFilter as { value?: string } | undefined)?.value ?? "";

  const setFilter = (field: string, value: string) => {
    const rest = filters.filter((f: { field: string }) => f.field !== field);
    const next = value ? [...rest, { field, op: "eq" as const, value }] : rest;
    navigate({
      search: {
        ...search,
        offset: 0,
        filters: next.length ? next : undefined,
      },
    });
  };

  const clearFilters = () => {
    navigate({
      search: {
        ...search,
        offset: 0,
        filters: undefined,
      },
    });
  };

  const hasFilters = currentStatus || currentTargetType;

  return (
    <div className="flex flex-wrap items-center gap-2 border-b px-4 pb-3">
      <Select
        value={currentTargetType || "all"}
        onValueChange={(v) => setFilter("targetType", v === "all" ? "" : v)}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="ປະເພດເປົ້າໝາຍ" />
        </SelectTrigger>
        <SelectContent>
          {TARGET_TYPE_OPTIONS.map((o) => (
            <SelectItem key={o.value || "all"} value={o.value || "all"}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={currentStatus || "all"}
        onValueChange={(v) => setFilter("status", v === "all" ? "" : v)}
      >
        <SelectTrigger className="w-[160px]">
          <SelectValue placeholder="ສະຖານະ" />
        </SelectTrigger>
        <SelectContent>
          {STATUS_OPTIONS.map((o) => (
            <SelectItem key={o.value || "all"} value={o.value || "all"}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {hasFilters && (
        <Button variant="ghost" size="sm" onClick={clearFilters}>
          ລ້າງຕົວກອງ
        </Button>
      )}
    </div>
  );
}
